import { render, staticRenderFns } from "./PointIcon.vue?vue&type=template&id=331ba1fc&"
import script from "./PointIcon.vue?vue&type=script&lang=js&"
export * from "./PointIcon.vue?vue&type=script&lang=js&"
import style0 from "./PointIcon.vue?vue&type=style&index=0&id=331ba1fc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports